import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Header from './navbar.js';
import '../css/login.css';
import { useDispatch, useSelector } from "react-redux";
import { login,getPublicKey } from '../store/Slices/authSlice.js';
import LoadingScreen from '../skeletons/loadingSkeleton.jsx';
import { encryptData } from '../helpers/encryptData.js';

const Login = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const loading = useSelector((state) => state.auth.loading);
    const adminEmail = process.env.REACT_APP_ADMIN_EMAIL;
    

    useEffect(() => {
        localStorage.setItem('email', '');
        // Fetch and store the public key when the component mounts
        dispatch(getPublicKey()).then((response) => {
            if (response?.payload?.publicKey) {
                localStorage.setItem('publicKey', response.payload.publicKey);
            } else {
                console.error('Public key not found in the response.');
            }
        }).catch((error) => {
            console.error('Error fetching public key:', error);
        });
    },[]);

    const handleEmailChange = (e) => {
        setEmail(e.target.value);

    };

    const handleEmailBlur = () => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email) && email.length > 0) {
            setError('Invalid email format');
        } else {
            setError('');
        }
    };


    const handlePasswordChange = (e) => {
        setPassword(e.target.value);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const loginData = { email: encryptData(email,localStorage.getItem("publicKey")), password: encryptData(password,localStorage.getItem("publicKey")) };
        dispatch(login(loginData)).then((response) => {
            if (response?.payload?.message === "Login successful") {
                sessionStorage.setItem('email', email);
                console.log(adminEmail);
                if (email === adminEmail) {
                    navigate("/admin", { state: { email: email, admin: true } });
                    return;
                }
                else {
                    navigate("/home");
                }
            }
            else {
                setError(response?.error?.message || 'Invalid email or password');
            }
        });
        // const demoEmail = "fkjdlas;jf"
        // localStorage.setItem('email', demoEmail);
        //navigate("/home" , {state: {email: demoEmail}});
    };

    return (
        <div>
            <Header />
            {loading ? <LoadingScreen /> :
                <div className="login-container">
                    <div>
                        <h1 style={{ marginLeft: '-48px', color: '#f16e00', fontWeight: 'bold' }}>Letter Of Authorization</h1>
                    </div>
                    <br></br>
                    <div>
                        <form onSubmit={handleSubmit} className="login-box" >
                            <div>
                                <label>Email:</label>
                                <input
                                    type="email"
                                    value={email}
                                    onChange={handleEmailChange}
                                    onBlur={handleEmailBlur}
                                    placeholder="Example@orange.com"
                                />
                                {error && <span style={{ color: 'red' }}>{error}</span>}
                            </div>
                            <div>
                                <label>Password:</label>
                                <input
                                    type="password"
                                    value={password}
                                    onChange={handlePasswordChange}
                                    placeholder="Enter password here"
                                />
                            </div>
                            <div className="account-help-links">
                                <Link to="/forgotPassword" className="account-help-link">
                                    Forgot Password
                                </Link>
                                <span className="account-help-divider" aria-hidden="true"></span>
                                <Link to="/resetPassword" className="account-help-link">
                                    Reset Password
                                </Link>
                            </div>
                            <button type="submit">Login</button>
                        </form>
                    </div>
                </div>
            }
        </div>
    );
};

export default Login;